<div class="container">
  @if (!activityLogData || activityLogData.length === 0) {
    <app-no-data></app-no-data>
  } @else {
    <nz-timeline [nzMode]="'left'">
      @for (activityLog of activityLogData; track activityLog.id) {
        <nz-timeline-item [nzLabel]="DateUtils.formatDate(activityLog.eventDate.toString(), 'dd/MM/yyyy, hh:mm a')">
          <div class="title">{{ activityLog.activity }}</div>
          <div class="event-item">
            @if (activityLog.eventData) {
              @for (event of Object.keys(activityLog.eventData); track $index) {
                <div class="event-value">{{ event }} : {{ activityLog.eventData[event] }}</div>
              }
            }
          </div>
        </nz-timeline-item>
      }
    </nz-timeline>
  }
</div>
